import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { update_colorconfig } from '../api/api';
import { toast } from 'react-toastify';

const ColorConfigModal = forwardRef(({ isOpen, onClose, colorConfigData }, ref) => {
  const [id, setId] = useState('');
  const [pdfColor, setPdfColor] = useState('');
  const [legendTitle, setLegendTitle] = useState('');
  const [tableTitle, setTableTitle] = useState('');
  const [bTier, setBTier] = useState(false);
  const [description, setDescription] = useState('');
  const [order, setOrder] = useState('');
  const [error, setError] = useState('');

  useImperativeHandle(ref, () => ({
    reset: () => {
      setId('');
      setPdfColor('');
      setError('');
      setLegendTitle('');
      setTableTitle('');
      setOrder('');
      setBTier(false);
    },
    setup: (data) => {
      setId(data?.id || '');
      setDescription(data?.table_title || '');
      setPdfColor(data?.pdf_color || '');
      setOrder(data?.order || '');
      setBTier(data?.b_tier || false);
      setLegendTitle(data?.legend_title || '');
      setTableTitle(data?.table_title || '');
      setError('');
    }
  }));

  const handleUpdate = async () => {
    if (!pdfColor.trim()) {
      setError("Il campo 'PDF Color' non può essere vuoto.");
      return;
    }

    try {
      await update_colorconfig(id, { pdf_color: pdfColor, b_tier: bTier, table_title: tableTitle, legend_title: legendTitle, order: order });
      toast.success("Aggiornamento completato");
      onClose();
    } catch (err) {
      console.error(err);
      setError("Errore durante l'aggiornamento. Riprova.");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title-document">Modifica Colore PDF</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <p style={{marginBottom:"15px"}}>
        Cliccare sul rettangolo per assegnare un colore customizzato da associare ai record di tipo &nbsp;
          <strong>
            {description}
          </strong>.
        </p>

        <div className="modal-content">
          <div className="modal-body">
            <label className="field-label" >Titolo Tabella</label>
            <input
              type="text"
              value={tableTitle}
              onChange={(e) => setTableTitle(e.target.value)}
              className="field-input"
              style={{ width: '500px', height: '30px', padding: '5px',cursor: 'pointer', marginBottom:"20px"  }}
            />

            <label className="field-label" >Titolo Legenda</label>
            <input
              type="text"
              value={legendTitle}
              onChange={(e) => setLegendTitle(e.target.value)}
              className="field-input"
              style={{ width: '500px', height: '30px', padding: '5px', cursor: 'pointer', marginBottom:"20px"  }}
            />


            <div style={{display:"flex", flexDirection:"row", justifyContent:"start"}}>
              <div>
                <label className="field-label" >Ordinamento</label>
                <input
                  type="number"
                  value={order}
                  onChange={(e) => setOrder(e.target.value)}
                  className="field-input"
                  style={{ width: '300px', height: '30px', padding: '5px', cursor: 'pointer', marginBottom:"20px"  }}
                />
              </div>


              <div style={{marginLeft:"20px"}}>
                <label className="field-label" >Leghe inferiori</label>
                <input
                  type="checkbox"
                  checked={bTier}
                  onChange={(e) => setBTier(e.target.checked)}
                  className="field-input"
                  style={{ width: '30px', height: '30px', padding: '0', border: 'none', cursor: 'pointer', marginBottom:"20px"  }}
                />
              </div>
            </div>

            <label className="field-label">Colore PDF</label>

            <input
              type="color"
              value={pdfColor}
              onChange={(e) => setPdfColor(e.target.value)}
              className="field-input"
              style={{ width: '50px', height: '50px', padding: '0', border: 'none', cursor: 'pointer' }}
            />
            {error && <div className="modal-error">{error}</div>}
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn btn-secondary" onClick={onClose}>Annulla</button>
          <button className="footer-btn btn-primary" onClick={handleUpdate}>Salva</button>
        </div>
      </div>
    </div>
  );
});

export default ColorConfigModal;
